import script from "./integralRule.vue?vue&type=script&setup=true&lang=js"
export * from "./integralRule.vue?vue&type=script&setup=true&lang=js"

import "./integralRule.vue?vue&type=style&index=0&id=6e7bf62c&lang=scss"

const __exports__ = script;

export default __exports__